import React, { FC } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { AuthStatus } from 'state/auth/reducer';
import { authRoleSelector, authStatusSelector } from 'state/auth/selectors';
import { onboardingScreenSelector } from 'state/onboarding/selectors';

import { OnboardingScreen } from 'pages/Onboarding/types';

import { RoutePath } from 'RoutePath';

import { UserRole } from 'types';

/**
 * VendorRoute
 * Renders underlying component if
 *  - user is logged in as vendor (otherwise redirects to login page or feed page)
 *  - user has completed or doesn't need onboarding (otherwise redirects to onboarding page)
 *
 * @param props: RouteProps
 */
export const VendorRoute: FC<RouteProps> = props => {
    const status = useSelector(authStatusSelector);
    const screen = useSelector(onboardingScreenSelector);
    const role = useSelector(authRoleSelector);
    switch (status) {
        case AuthStatus.LOGGED_IN:
            if (role === UserRole.CUSTOMER) {
                window.location.assign(RoutePath.FEED);
                return null;
            }
            return screen && screen !== OnboardingScreen.SUCCESS ? (
                <Redirect to={RoutePath.REGISTRATION} />
            ) : (
                <Route {...props} />
            );
        case AuthStatus.GUEST:
            return <Redirect to={RoutePath.LOGIN} />;
        default:
            return null;
    }
};
